<template>
	<v-tooltip bottom content-class="tooltip-content tooltip-data">
		<template v-slot:activator="{ on, attrs }">
			<span v-bind="attrs" v-on="on">
				<span class="activator-text ml-1 text underline"> {{ activatorText }}</span>
			</span>
		</template>
		<h3 class="tooltip-title" v-if="tooltipTitle">{{ tooltipTitle }}</h3>
		<ul class="tooltip-items-container">
			<li class="tooltip-row" v-for="(item, index) in tooltipItems" :key="item + '_' + index">
				{{ item }}
			</li>
		</ul>
	</v-tooltip>
</template>

<script>
export default {
	name: 'Tooltip',
	components: {},
	props: { activatorText: { type: String }, tooltipItems: { type: Array }, tooltipTitle: { type: String } },
	computed: {},
	methods: {},
};
</script>

<style scoped lang="scss">
.tooltip-title {
	font-weight: 700;
}
.activator-text {
	padding: 6px 7px;
}
.tooltip-data {
	opacity: 1;
	background-color: white;
	color: black;
	box-shadow: 0px 4px 4px 0px #00000040;
	padding: 12px 15px;
	border-radius: 5px;
	.tooltip-row {
		width: 250px;
		padding: 3px 0px;
		font-size: 14px;
	}
}
.tooltip-items-container {
	list-style-type: disc;
	margin-left: -2% !important;
}
</style>
